import pinyinPkg from 'pinyin'

const pinyinFn =
  typeof pinyinPkg === 'function'
    ? pinyinPkg
    : pinyinPkg && typeof pinyinPkg.default === 'function'
      ? pinyinPkg.default
      : pinyinPkg
const PINYIN_STYLE =
  (pinyinFn && pinyinFn.STYLE_NORMAL) != null
    ? pinyinFn.STYLE_NORMAL
    : 0

const MULTI_MARKERS = ['②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨']

function extraMultimeaningCount (voc) {
  const chineseText = voc.chineseText || ''
  let extraMeaningCount = 0
  for (let i = 0; i < MULTI_MARKERS.length; i++) {
    if (chineseText.includes(MULTI_MARKERS[i])) {
      extraMeaningCount = i + 1
    }
  }
  return extraMeaningCount
}

function isChinese (text) {
  const re =
    /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/g
  return re.test(text)
}

function retrieveCnMeaning (text) {
  const substr = '释义：'
  const indices = []
  for (const match of String(text).matchAll(new RegExp(substr, 'g'))) {
    indices.push(match.index + substr.length)
  }
  const result = []
  for (let i = 0; i < indices.length; i++) {
    const start = indices[i]
    const end = text.indexOf('<', start)
    result.push(text.substring(start, end === -1 ? text.length : end))
  }
  return result
}

function generateOriginalCnTextArray (text) {
  const rawCnMeaningArray = String(text || '').includes('释义：')
    ? retrieveCnMeaning(text)
    : [text]
  const resultCnArray = []
  for (let j = 0; j < rawCnMeaningArray.length; j++) {
    const cnTextArray = String(rawCnMeaningArray[j] || '').split(
      /[,，.。、;；:：?？!！ ]/
    )
    for (let i = 0; i < cnTextArray.length; i++) {
      if (isChinese(cnTextArray[i])) {
        resultCnArray.push(cnTextArray[i].replace('…', ''))
        if (cnTextArray[i].includes('的')) {
          resultCnArray.push(cnTextArray[i].replace('…', '').replace('的', ''))
        }
        if (cnTextArray[i].includes('地')) {
          resultCnArray.push(cnTextArray[i].replace('…', '').replace('地', ''))
        }
      }
    }
  }
  return resultCnArray
}

function processEnAnswer (answer) {
  if (
    !answer.englishStudentAnswer ||
    answer.englishStudentAnswer === 'NOT Answered'
  ) {
    answer.enAnswerResult = false
    return
  }
  const expected = String(answer.englishText || '')
    .trim()
    .toLowerCase()
  const given = String(answer.englishStudentAnswer).trim().toLowerCase()
  answer.enAnswerResult = expected === given
}

function processCnAnswer (answers, index) {
  const answer = answers[index]
  answer.cnAnswerResult = false
  if (
    !answer.chineseStudentAnswer ||
    answer.chineseStudentAnswer === 'NOT Answered'
  ) {
    return
  }

  if (answer.multiMeaningIndex && answer.multiMeaningIndex > 1) {
    const multiMeaningIndex = answer.multiMeaningIndex
    for (let i = index - multiMeaningIndex + 1; i < index; i++) {
      if (answer.chineseStudentAnswer === answers[i].chineseStudentAnswer) {
        answer.cnAnswerResult = false
        return
      }
    }
  }

  const correctedAnswers = [
    ...(answer.correctedAnswers || []).map((item) => item && item.trim()),
    ...generateOriginalCnTextArray(answer.chineseText)
  ].filter((item) => item != null && item !== '')

  const originalStuAnswer = String(answer.chineseStudentAnswer).trim()
  const stuAnswer = originalStuAnswer.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '')
  const correctedAnswersWithoutPunctuation = correctedAnswers
    .filter(Boolean)
    .map((item) => item.trim().replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, ''))

  if (correctedAnswersWithoutPunctuation.includes(stuAnswer)) {
    answer.cnAnswerResult = true
    return
  }

  const pinyinStuCnAnswer = pinyinFn(stuAnswer, {
    style: PINYIN_STYLE
  }).join('')
  const pinyinCorrectedAnswers = correctedAnswersWithoutPunctuation.map((item) =>
    pinyinFn(item, { style: PINYIN_STYLE }).join('')
  )
  if (pinyinCorrectedAnswers.includes(pinyinStuCnAnswer)) {
    answer.cnAnswerResult = true
  }
}

function processAnswerByTestType (answers, index, type, result) {
  switch (type) {
    case 1:
    case 6:
      result.haveEnResult = true
      result.haveCnResult = false
      processEnAnswer(answers[index])
      answers[index].bothResult = !!answers[index].enAnswerResult
      break
    case 2:
      result.haveEnResult = true
      result.haveCnResult = true
      processEnAnswer(answers[index])
      processCnAnswer(answers, index)
      answers[index].bothResult = !!(
        answers[index].enAnswerResult && answers[index].cnAnswerResult
      )
      break
    case 3:
    case 4:
      result.haveEnResult = false
      result.haveCnResult = true
      processCnAnswer(answers, index)
      answers[index].bothResult = !!answers[index].cnAnswerResult
      break
    default:
      break
  }
}

function processMultimeaningVoc (answers) {
  for (let i = 0; i < answers.length; i++) {
    const extraMeaningCount = extraMultimeaningCount(answers[i])
    answers[i].meaningCount = extraMeaningCount + 1
    if (extraMeaningCount > 0) {
      answers[i].multiMeaningIndex = 1
      let multiStudentAnswersArray = []
      if (
        answers[i].chineseStudentAnswer &&
        answers[i].chineseStudentAnswer.length > 0 &&
        answers[i].chineseStudentAnswer.includes('&')
      ) {
        multiStudentAnswersArray = answers[i].chineseStudentAnswer
          .replace('null', '')
          .replace('undefined', '')
          .split('&')
        answers[i].chineseStudentAnswer = multiStudentAnswersArray[0] || ''
      }
      for (let j = 0; j < extraMeaningCount; j++) {
        answers.splice(i + j, 0, JSON.parse(JSON.stringify(answers[i + j])))
        answers[i + 1 + j].multiMeaningIndex += 1
        answers[i + 1 + j].chineseStudentAnswer =
          multiStudentAnswersArray[1 + j] || ''
      }
    }
    i += extraMeaningCount
  }
}

function generateAnswerResultWithoutMultimeaning (answers, result) {
  for (let i = 0; i < answers.length; i++) {
    if (result.haveEnResult && answers[i].enAnswerResult) result.enCorrect += 1
    if (result.haveCnResult && answers[i].cnAnswerResult) result.cnCorrect += 1
    if (answers[i].bothResult) result.bothCorrect += 1
  }
  result.vocCount = answers.length
}

function generateAnswerResult (answers, result) {
  let allExtrameaningCount = 0
  for (let i = 0; i < answers.length; i++) {
    const extraMeaningCount = extraMultimeaningCount(answers[i])
    if (extraMeaningCount <= 0) {
      if (result.haveEnResult && answers[i].enAnswerResult) result.enCorrect += 1
      if (result.haveCnResult && answers[i].cnAnswerResult) result.cnCorrect += 1
      if (answers[i].bothResult) result.bothCorrect += 1
    } else {
      let multiEnIsCorrect = true
      let multiCnIsCorrect = true
      let multiBothIsCorrect = true
      for (let j = 0; j < extraMeaningCount + 1; j++) {
        if (!result.haveEnResult || !answers[i + j] || !answers[i + j].enAnswerResult) {
          multiEnIsCorrect = false
        }
        if (!result.haveCnResult || !answers[i + j] || !answers[i + j].cnAnswerResult) {
          multiCnIsCorrect = false
        }
        if (!answers[i + j] || !answers[i + j].bothResult) {
          multiBothIsCorrect = false
        }
      }
      if (multiEnIsCorrect) result.enCorrect += 1
      if (multiCnIsCorrect) result.cnCorrect += 1
      if (multiBothIsCorrect) result.bothCorrect += 1
      allExtrameaningCount += extraMeaningCount
      i += extraMeaningCount
    }
  }
  result.vocCount = answers.length - allExtrameaningCount
}

function percentText (correct, total) {
  if (!total) return '0%'
  return Math.round((correct / total) * 10000) / 100 + '%'
}

function isPass (correct, total) {
  return total > 0 && correct / total >= 0.9
}

function scoreLine (label, correct, total) {
  const text = `${label}${correct}/${total} ${percentText(correct, total)}`
  const pass = isPass(correct, total)
  return { text, pass }
}

function formatScoreSummary (result, type) {
  if (type === 2 && result.haveEnResult && result.haveCnResult) {
    const lines = [
      scoreLine('英 ', result.enCorrect, result.vocCount),
      scoreLine('中 ', result.cnCorrect, result.vocCount)
    ]
    return {
      scoreText: lines.map((line) => line.text).join('\n'),
      scorePass: lines.every((line) => line.pass),
      lines
    }
  }
  if (result.haveCnResult && !result.haveEnResult) {
    const lines = [scoreLine('', result.cnCorrect, result.vocCount)]
    return {
      scoreText: lines[0].text,
      scorePass: lines[0].pass,
      lines
    }
  }
  const lines = [scoreLine('', result.enCorrect, result.vocCount)]
  return {
    scoreText: lines[0].text,
    scorePass: lines[0].pass,
    lines
  }
}

export function summarizeTestScore (testItem) {
  const answers = Array.isArray(testItem && testItem.studentAnswers)
    ? testItem.studentAnswers.map((item) => ({
        ...item,
        correctedAnswers: Array.isArray(item.correctedAnswers)
          ? [...item.correctedAnswers]
          : []
      }))
    : []

  if (!answers.length) {
    return {
      scoreText: '无答案',
      scorePass: false,
      lines: [{ text: '无答案', pass: false }]
    }
  }

  const type = testItem.type
  if (type !== 1 && type !== 6 && type !== 5 && type !== 7) {
    processMultimeaningVoc(answers)
  }
  if (type === 5 || type === 7) {
    const vocCount = answers.length
    const correct = answers.filter((item) => item.isCorrect).length
    const lines = [scoreLine('', correct, vocCount)]
    return {
      scoreText: lines[0].text,
      scorePass: lines[0].pass,
      lines
    }
  }

  const result = {
    haveEnResult: false,
    haveCnResult: false,
    enCorrect: 0,
    cnCorrect: 0,
    bothCorrect: 0,
    vocCount: 0
  }

  for (let i = 0; i < answers.length; i++) {
    if (!answers[i].englishStudentAnswer && !answers[i].chineseStudentAnswer) {
      answers[i].enAnswerResult = false
      answers[i].cnAnswerResult = false
      answers[i].bothResult = false
      continue
    }
    processAnswerByTestType(answers, i, type, result)
  }

  if ([1, 6].includes(type)) {
    generateAnswerResultWithoutMultimeaning(answers, result)
  } else {
    generateAnswerResult(answers, result)
  }

  return formatScoreSummary(result, type)
}

export function testScoreKey (row) {
  return String(row && row.id != null ? row.id : '')
}
